import { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { BaseChangedCell } from './BaseChangedCell';

type Props = {
  params: GridRenderCellParams;
  showChanges: boolean;
  field?: string;
};

export const DefaultChangedCell = (props: Props) => {
  const { params, showChanges, field } = props;
  const fieldKey = field ?? params.field;

  const changes = params.row.changes;
  const cv = changes?.[fieldKey];

  if (showChanges && cv) {
    return <BaseChangedCell oldValue={cv.old} newValue={cv.new} />;
  }

  return params.value ?? '';
};
